import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/DeviceMobile.es.js";
const o = e.forwardRef((i, c) => /* @__PURE__ */ e.createElement(r, { ref: c, ...i, weights: t }));
o.displayName = "DeviceMobileIcon";
const s = o;
export {
  s as DeviceMobile,
  o as DeviceMobileIcon
};
